import React from 'react';
import styled from 'styled-components';
//
import ProductItems from 'components/deal-results/product-items';
import GeneralInformation from 'components/deal-results/general-information';
import AdditionalMandate from 'components/deal-results/additional-mandate-view';

const Container = styled.div`
  padding-left: 32px;
  padding-top: 16px;
  min-height: calc(100vh - 150px);
`;

const Section = styled.div`
  margin-bottom: 40px;
`;

const ProductItemsSection = styled(Section)`
  padding-right: 16px;
`;

const GeneralInformationSection = styled(Section)`
  padding: 0px 16px;
`;

const DealResults = () => {
  return (
    <Container>
      <GeneralInformationSection>
        <GeneralInformation />
      </GeneralInformationSection>

      <ProductItemsSection>
        <ProductItems />
      </ProductItemsSection>
      <GeneralInformationSection>
        <AdditionalMandate />
      </GeneralInformationSection>
    </Container>
  );
};

export default DealResults;
